<template lang="html">
  <div class="">
    <h1>Slide inspector</h1>
    <p>Transition type</p>
    <p>Transition time</p>
    <p>Remove slide button</p>
    <p>Motion direction and speed presets</p>
    <p>Image entrance</p>
    <p>Image exit</p>
    <p>Maintain image fill</p>
    <p>Caption</p>
    <p>Link to project inspector for caption enable/disable</p>
  </div>
</template>

<script>
export default {
  name: "SlideInspector"
};
</script>

<style lang="css" scoped></style>
